import React from 'react';
import { Helmet } from 'react-helmet-async';


interface Props {
  themeSlug: string;
}


export function PortalStylesheet(props: Props) {
  const stylesheetUrl = `${process.env.PUBLIC_URL}/themes/${props.themeSlug}.css?v=${process.env.REACT_APP_THEME_DIGEST}`;

  // index.html should already have determined the correct stylesheet, but if we can't find it, load it
  if (Array.from(document.getElementsByTagName('link')).find(l => {
    return l.title === 'default' && (stylesheetUrl.indexOf(l.href) >= 0 || l.href.indexOf(stylesheetUrl) >= 0);
  })) {
    return null;
  }
  
  return (
    <Helmet>
      <link href={stylesheetUrl} rel="stylesheet"/>
    </Helmet>
  );
}